var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticStyle: { height: "80vh" } },
        [
          _c("el-page-header", {
            attrs: { content: "礼包详情" },
            on: {
              back: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          }),
          _c("div", { staticClass: "ac_tabs" }, [
            _c(
              "div",
              { staticClass: "ac_tabs-contain" },
              [
                _c(
                  "el-descriptions",
                  { attrs: { column: 4, size: "small", border: "" } },
                  [
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "礼包名称" } },
                      [_vm._v(_vm._s(_vm.info.giftName))]
                    ),
                    _c("el-descriptions-item", { attrs: { label: "礼包Id" } }, [
                      _vm._v(_vm._s(_vm.info.giftId)),
                    ]),
                    _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                      _vm._v(_vm._s(_vm.info.status)),
                    ]),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "归属批次Id" } },
                      [_vm._v(_vm._s(_vm.info.batchId))]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "已绑定金额" } },
                      [_vm._v(_vm._s(_vm.info.bindAmount))]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "礼包数量" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.info.giftNum) +
                            "\n            "
                        ),
                        _vm.info.status !== "已作废"
                          ? _c(
                              "span",
                              { staticStyle: { "padding-left": "10px" } },
                              [
                                _vm.info.split !== "是"
                                  ? _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "right",
                                          width: "250",
                                          trigger: "click",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form",
                                          {
                                            attrs: {
                                              model: _vm.form,
                                              size: "mini",
                                              inline: true,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              [
                                                _c("el-input", {
                                                  staticStyle: { width: "8vw" },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value: _vm.form.num,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "num",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.num",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "success" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.submit.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("确定")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: ["coupon_add_more"],
                                                expression:
                                                  "['coupon_add_more']",
                                              },
                                            ],
                                            attrs: {
                                              slot: "reference",
                                              type: "primary",
                                              size: "mini",
                                            },
                                            slot: "reference",
                                          },
                                          [_vm._v("增发")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "礼包剩余数量" } },
                      [_vm._v(_vm._s(_vm.info.remainNum))]
                    ),
                    _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
                      _vm._v(_vm._s(_vm.info.creatUser)),
                    ]),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "创建时间" } },
                      [_vm._v(_vm._s(_vm.info.creatTime))]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "内部优惠券是否可拆分" } },
                      [_vm._v(_vm._s(_vm.info.split))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "ac_tabs", staticStyle: { height: "80%" } },
            [
              _c("div", { staticClass: "ac_tabs_nav-wrap" }, [
                _c("div", { staticClass: "ac_tabs-items" }, [
                  _c("span", [_vm._v("优惠券")]),
                  _vm.info.status !== "已作废"
                    ? _c(
                        "span",
                        { staticStyle: { "padding-left": "20px" } },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["coupon_add"],
                                  expression: "['coupon_add']",
                                },
                              ],
                              attrs: {
                                type: "success",
                                size: "mini",
                                icon: "el-icon-plus",
                              },
                              on: { click: _vm.handleCouponCreate },
                            },
                            [_vm._v("创建优惠券")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "ac_tabs-contain",
                  staticStyle: { height: "78%" },
                },
                [
                  _c(
                    "yd-table",
                    {
                      attrs: {
                        loading: _vm.loading,
                        data: _vm.data,
                        size: "mini",
                        pagination: _vm.page,
                        height: "450px",
                      },
                      on: { onChange: _vm.onTableChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "优惠券ID",
                          width: "150",
                          prop: "couponId",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "优惠券名称",
                          prop: "couponName",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handlePkgView(
                                          scope.row.couponId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.couponName))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "面值",
                          prop: "faceValue",
                          width: "60",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "总量",
                          prop: "remainNum",
                          width: "88",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "有效期",
                          prop: "validDate",
                          width: "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "可用业务", prop: "bu" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "可用范围", width: "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "range-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      Array.isArray(scope.row.range)
                                        ? scope.row.range.join(";")
                                        : ""
                                    )
                                  ),
                                ]),
                                Array.isArray(scope.row.range) &&
                                scope.row.range.length > 4
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moreRange(
                                              scope.row.range
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("查看更多")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "创建人",
                          prop: "creatName",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "创建时间",
                          prop: "creatTime",
                          width: "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态", prop: "state", width: "88" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "180", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.stateCode !== 3 ||
                                scope.row.stateCode === 2
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "padding-right": "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom",
                                              title:
                                                "增发 【" +
                                                scope.row.couponName +
                                                "】 优惠券",
                                              width: "280",
                                              trigger: "click",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-form",
                                              {
                                                attrs: {
                                                  model: _vm.form,
                                                  inline: true,
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  [
                                                    _c("avue-input-number", {
                                                      staticStyle: {
                                                        width: "8vw",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        clearable: "",
                                                        minRows: "0",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.couponNum,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "couponNum",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.couponNum",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-form-item",
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.handleNewAddCoup(
                                                              scope.row.couponId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("确定")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "has-permi",
                                                    rawName: "v-has-permi",
                                                    value: ["coupon_add_more"],
                                                    expression:
                                                      "['coupon_add_more']",
                                                  },
                                                ],
                                                attrs: {
                                                  slot: "reference",
                                                  type: "text",
                                                  size: "mini",
                                                },
                                                slot: "reference",
                                              },
                                              [_vm._v("增发")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                scope.row.stateCode !== 3
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "has-permi",
                                            rawName: "v-has-permi",
                                            value: ["coupon_delete"],
                                            expression: "['coupon_delete']",
                                          },
                                        ],
                                        attrs: { size: "mini", type: "text" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleZuofei(
                                              scope.row.couponId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("作废")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handlePkgDataView(
                                          scope.row.couponId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("数据")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "可用范围",
            visible: _vm.moreVisible,
            "append-to-body": true,
            width: "50%",
            "before-close": "closeMoreRange",
          },
          on: {
            "update:visible": function ($event) {
              _vm.moreVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "range-box" },
            _vm._l(this.range, function (item, index) {
              return _c("div", { key: index }, [
                _c("span", { staticStyle: { "padding-left": "15px" } }, [
                  _vm._v(_vm._s(item)),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
      _c("coupon-pkg-create", {
        ref: "couponCreate",
        on: { refreshDetailsList: _vm.onLoad },
      }),
      _vm.pkgViewVisible
        ? _c("pkg-view", {
            ref: "pkgView",
            on: { refreshDataList: _vm.onLoad },
          })
        : _vm._e(),
      _vm.pkgDataViewVisible
        ? _c("pkg-data-view", { ref: "pkgDataView" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }